import { array, nullish, object, record, string } from 'valibot'

export const solrHighlightingSchema = record(
  string(),
  object({
    bodytext: nullish(array(string())),
    title: nullish(array(string())),
    abstract: nullish(array(string())),
    chapterTitle: nullish(array(string())),
    paragraphTitle: nullish(array(string())),
    keywords_lc: nullish(array(string())),
    shortTitle: nullish(array(string())),
  }),
)
